import filterConstants from '../constants';

const workload = mode => {
  const config = {
    id: null,
    name: null,
    type: filterConstants.FILTERS.workload,
    properties: {
      [filterConstants.PROPERTY.text]: '',
    },
  };

  const commonProps = {
    [filterConstants.PROPERTY.type]: '',
    [filterConstants.PROPERTY.assignee]: '',
    [filterConstants.PROPERTY.status]: '',
    [filterConstants.PROPERTY.priority]: '',
    [filterConstants.PROPERTY.reporter]: '',
    [filterConstants.PROPERTY.startDate]: '',
    [filterConstants.PROPERTY.endDate]: '',
    [filterConstants.PROPERTY.creationDate]: '',
    [filterConstants.PROPERTY.color]: '',
    [filterConstants.PROPERTY.overdue]: '',
  };

  if (mode === 'multi') {
    config.properties = { ...config.properties, ...{ [filterConstants.PROPERTY.gantt_id]: '' } };
  }

  config.properties = { ...config.properties, ...commonProps };

  return config;
};

export default workload;
